'use strict';

/*@ngInject*/
module.exports = function ($scope, $translate, $anchorScroll, $location, platform, $http, urlFormats) {
    // $scope.scrollTo = $stateParams.scrollTo;
    $scope.platform = platform;

    var osvalue = $scope.platform.os.family.toLowerCase();

    if ($location.search().data) {
        $scope.androidDownloadLink = urlFormats.android.googlePlay + $location.search().data;
        $scope.iosDownloadLink = urlFormats.ios.appStore + $location.search().data;
        $scope.windowDownloadLink = urlFormats.windows.windowsStore + "?name=SafeFamilySetup_" + $location.search().data + ".exe";
    } else {
        $scope.androidDownloadLink = urlFormats.android.googleDefault;
        $scope.iosDownloadLink = urlFormats.ios.appstoreDefault;
        $scope.windowDownloadLink = urlFormats.windows.windowsDefault;
    }


    if (osvalue === undefined) {
        window.location.href = '/undl';
        return false;
    } else if (osvalue.indexOf('ios') !== -1) {
        //console.log('ios' + ios_url);
        //window.ga('send', 'event', 'Download', 'Click', 'iOS-redirect');
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("iOS-redirect")
            .action('Click')
            .label('Download')
            .finish();
        window.location.href = $scope.iosDownloadLink;

    }
    else if (osvalue.indexOf('android') !== -1) {
        //window.ga('send', 'event', 'Download', 'Click', 'Android-redirect');
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Android-redirect")
            .action('Click')
            .label('Download')
            .finish();

        window.location.href = $scope.androidDownloadLink;

        /*
        var redirect_url = $scope.androidDownloadLink;
        var android_url = $scope.androidDownloadLink;
        var fromUrl = $location.absUrl();

        if (fromUrl.indexOf('utm_source') !== -1 && fromUrl.indexOf('utm_medium') !== -1) {
            var paramOne;
            var params = {};
            var res = fromUrl.split("?");

            if (res[1] !== undefined) {
                paramOne = res[1].split("/")[0];

                var temp = paramOne.split("&");


                for (var i = 0; i < temp.length; i++) {
                    res = temp[i].split("=");
                    params[res[0]] = res[1];

                }

                if (params.utm_source !== undefined && params.utm_medium !== undefined)  // apply what url come from
                {
                    temp = android_url.split("referrer=");
                    redirect_url = temp[0] + "referrer=" + paramOne;
                }

            }

        }

        window.location.href = redirect_url;
        */
    }
    else if (osvalue.indexOf('windows') !== -1) {

        //window.ga('send', 'event', 'Download', 'Click', 'Windows-redirect');
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Windows-redirect")
            .action('Click')
            .label('Download')
            .finish();
        //window.location.href = win_url;

        //window.location.href = './#/undl';	


        $location.path('/download');



    } else {
        $location.path('/undl');

    }

    $scope.getFromUrl = function () {
        return $location.absUrl();
    };
    $scope.getClientInfo = function () {
        return 'OS: ' + platform.os.family + ' browser:' + platform.name + ' desc: ' + platform.description;
    };


    //console.log("win location : " + window.location.href +  " iospath:" + iospath );
    return false;
};